import { render } from "./ConversationWindow.vue?vue&type=template&id=116a5341&scoped=true"
import script from "./ConversationWindow.vue?vue&type=script&lang=js"
export * from "./ConversationWindow.vue?vue&type=script&lang=js"

import "./ConversationWindow.vue?vue&type=style&index=0&id=116a5341&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116a5341"]])

export default __exports__